module dg.restfulApi {
    angular.module('dg.restfulApi', []);

    export interface ApiSettings {
        version: number;
    }

    export interface DomainObjectMetadata extends DomainTypeMetadata {
        isMerged?: boolean;//HACK: client side property (fix multi ime merge probleme for notDefined properties merge)
        //properties: DomainObjectPropertiesMetadata;
        autoInvoke?: boolean;
    }

    export interface DomainObjectPropertyMetadata extends DomainTypePropertyMetadata {
        //propertyType: string;

        notDefined?: boolean;
        taskStatus: any;
        //aggregateId?: string;
        //displayValue?: string;
    }

    export interface DomainObjectPropertiesMetadata {
        [propertyName: string]: DomainObjectPropertyMetadata
    };

    export interface Links {
        [linkId: string]: Link;
    }

    export interface Link {
        getDynamicParams?: () => any;
    }

    export interface ErrorResult {
        handeled?: boolean;
    }


    export interface IDgExtensions {
        validation?: {
            rules: Array<ValidationRule>;
        };
        multiPartPropertyValue?: {
            delimiter: string;
            options: Array<string>
        }
    }

    export interface ValidationRule {
        type: string;
        code: string;
        params: { [paramName: string]: any };
        message: string;
        condition: any;
    }

    export class DG_LINK_RELS {
        public static get invoke() { return 'urn:org.digmo:rels/invoke'; }
        public static get action() { return 'urn:org.digmo:rels/action'; }
        public static get query() { return 'urn:org.digmo:rels/query'; }
        public static get confirmationAction() { return 'urn:org.digmo:rels/confirmation-action'; }
        public static get self() { return 'self'; }
        public static get queryResult() { return 'urn:org.digmo:rels/query-result'; }
        public static get uploadAction() { return 'urn:org.digmo:rels/upload-action'; }
        public static get persist() { return 'urn:org.digmo:rels/persist'; }
        public static get export() { return 'urn:org.digmo:rels/export'; }
        public static get external() { return 'urn:org.digmo:rels/external'; }
        public static get errors() { return 'urn:org.digmo:rels/errors'; }
    }


    export type PropertyType = "ChildObject" | "Reference" | "Scalar";


    export class DG_EVENTS {
        //public static get commandSuccessfullyExecuted() { return 'dg:commadSuccess'; }
        public static get lightboxEditModalDismissed() { return 'dg:lightboxEditModalDismissed'; }
        public static get querySuccessfullyLoaded() { return 'dg:querydSuccess'; }
        public static get executeQuery() { return 'dg:executeQuery'; }
    }

    export class DG_DATA_TYPES {
        public static get String() { return 'String'; }
        public static get Bool() { return 'Bool'; }
        public static get Number() { return 'Number'; }
        public static get Date() { return 'Date'; }
        public static get DateTime() { return 'DateTime'; }
        public static get MultilineText() { return 'MultilineText'; }
        public static get RichText() { return 'Html'; }
        public static get Url() { return 'Url'; }
        public static get EmailAddress() { return 'EmailAddress'; }
        public static get ExternalFile() { return 'ExternalFile'; }
        public static get BlobFile() { return 'BlobFile'; }
        public static get Base64File() { return 'Base64File'; }
        public static get DateRange() { return 'DateRange'; }
        public static get MonthRange() { return 'MonthRange'; }
        public static get SingleWord() { return 'SingleWord'; }
        public static get ObjectCode() { return 'ObjectCode'; }
        public static get ObjectName() { return 'ObjectName'; }
        public static get AzureUserNameWithoutDomain() { return 'AzureUserNameWithoutDomain'; }
        public static get Period() { return 'Period'; }
        public static get Amount() { return 'Amount'; }
        public static get Percent() { return 'Percent'; }
    }
}

module dg.domain {
    export interface IDomainObject {
        dgMeta: dg.restfulApi.DomainObjectMetadata
    }
}

module dg.domain.model {

    export type PeriodType = "Month" | "Quarter" | "Year"

    export type TaskStatus = "InProgress" | "Failed"
    //export const enum PeriodType {
    //	Month = 1,
    //	Quarter = 2,
    //	Year = 3
    //}

    export interface DomainModelRefInfo extends dg.domain.IDomainObject {
        id: string,
        displayValue: string
    }

    //HACK: 
    export interface Tag extends DomainModelRefInfo {
        isNew?: boolean;//client side attribute for new tags
    }

    export interface CreateTagCommand extends dg.domain.commands.AggregateCommandBase {
        modelType: string;
        name: string;
        tagGroupId: number;
    }
}

module dg.domain.actions {

    export interface IDomainAction extends IDomainObject {
    }

    interface IPatternCriterion {
        pattern: string;
    }


    export interface ISortable {
        sortCriteria: dg.domain.queries.SortCriterion[];
        sortFields: dg.domain.queries.LookupItem<string>[];
    }

    export interface IPageable {
        pageNumber: number;
        pageSize: number;
    }
}

module dg.domain.commands {

    export interface CommandBase extends dg.domain.actions.IDomainAction {
    }
}

module dg.domain.queries {

    //export interface ListQuery extends ListQuery<IDomainObject> {
    //}

    export interface ListQueryResult<TModel> {
        dgMeta: dg.restfulApi.DomainObjectMetadata
    }

    export interface SortCriterion {
        displayValue: string;
    }

    //export interface ListQueryResult extends ListQueryResult<IDomainObject> {
    //}

    export interface ModelQueryResult<TDomainModel> {
        dgMeta: dg.restfulApi.DomainObjectMetadata
    }

    export interface QueryBase<TResult> extends IQueryAction {
    }

    export interface IQueryAction extends dg.domain.actions.IDomainAction {
    }

}


module dg.domain.artifacts {

    export interface ArtifactStages<TDomainModel> {

    }


    export interface ArtifactMilestones<TDomainModel> {

    }



}

